import { GenericResponse, TableRequestV3, TableResponse } from 'services/types'
import { employeeApi } from './employee'
import { AddWorkPlanRequest, AddWorkPlanResponse, EmployeeBaseSearchRequest } from './types'
import { sendNotification } from 'components'
import { DropdownOptionTemplate } from 'types/common'

const workPlanApi = employeeApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkPlanList: build.query<TableResponse<{}>, TableRequestV3 & { employeeId?: string }>({
      query: ({ clientId, employeeId, ...data }) => ({
        url: `clients/${clientId}/work_plan/list/`,
        params: {
          employee_id: employeeId,
        },
        method: 'POST',
        data,
      }),
      providesTags: ['WorkPlans'],
    }),
    addWorkPlan: build.mutation<AddWorkPlanResponse, AddWorkPlanRequest>({
      query: ({ clientId, ...data }) => ({
        url: `clients/${clientId}/work_plan/`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['WorkPlans'],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          sendNotification({
            type: 'success',
            toastContent: data.detail.message,
          })
        } catch (err) {}
      },
    }),
    searchWorkPlan: build.query<
      GenericResponse & { work_plan_list: DropdownOptionTemplate<string> },
      EmployeeBaseSearchRequest
    >({
      query: ({ clientId, searchParam, employeeId, exact }) => ({
        url: `clients/${clientId}/work_plan/search/`,
        method: 'GET',
        params: {
          search_param: searchParam,
          employee_id: employeeId,
          exact,
        },
      }),
    }),
  }),
})

export const { useGetWorkPlanListQuery, useAddWorkPlanMutation, useLazySearchWorkPlanQuery } =
  workPlanApi
